import { defineStore } from "pinia";
import Services from '@/services/sutting/almelakatServices'
import { mapList, mapAlmelakat } from '@/helpers/mapFuncs'

export const useAlmelakatStore = defineStore("almelakats", {
persist: true,
state:()=>({
    almelakat: {},
    almelakats: [],
}),
getters : {
    getAlmelakat() {
        return mapAlmelakat(this.almelakat)
    },
    getAlmelakats() {
        return this.almelakats.map(mapAlmelakat)
    },
    getAlmelakatsList() {
        return this.almelakats.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setAlmelakat(almelakat) {
        this.almelakat = almelakat
    },
    setAlmelakats(almelakats) {
        this.almelakats = almelakats
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setAlmelakat(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setAlmelakats(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.almelakats.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.almelakats[this.almelakats.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.almelakats = this.almelakats.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
